<script setup lang="ts">
const paginationContext = usePaginationContext();

defineProps<{
  ariaLabel?: string;
}>();
</script>

<template>
  <PaginationButton
    :disabled="paginationContext.isPrevDisabled.value"
    :aria-label="ariaLabel ?? $t('Pagination.Aria.PrevPageButton')"
    :on-click="paginationContext.prevPage"
  >
    <BaseIcon
      name="prev"
      prefix="pagination"
    />
  </PaginationButton>
</template>
